import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { NavLink, useSearchParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import Pagination from "../General/Pagination";
import LibraryMenu from "./LibraryMenu";
import { Form } from "react-bootstrap";
import csvDownload from "json-to-csv-export";

const BorrowHistory = () => {
  const [searchParams] = useSearchParams();
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [userType, setUserType] = useState(searchParams.get("type") === "staff" ? "staff" : "student");
  const [memberCode, setMemberCode] = useState(searchParams.get("code") || "");
  const [searched, setSearched] = useState(false);
  const [listOfRecords, setListOfRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [lastSearchType, setLastSearchType] = useState("");
  const [lastSearchCode, setLastSearchCode] = useState("");
  const [deepLinkStudentId, setDeepLinkStudentId] = useState(
    parseInt(searchParams.get("studentId") || "0", 10) || 0
  );

  document.title = "Borrow History";

  const fetchHistory = (code, type, page, size, studentId = 0) => {
    if (!studentId && (!code || code.trim() === "")) {
      toast.error("Please enter a registration number or employee code.", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: page,
      pageSize: size,
      Registration_No: type === "student" ? (code || "").trim() : "",
      EmployeeCode: type === "staff" ? (code || "").trim() : "",
    };
    if (studentId > 0) {
      data.Student_ID = studentId;
    }

    axios({
      method: "post",
      url: config.base_url + "Library/GetBorrowHistoryReport",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setListOfRecords(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
        } else {
          setListOfRecords([]);
          setTotalRecords(0);
          toast.error(response.data.status_message || "No records found.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
        toast.error("Network Error..", { position: toast.POSITION.TOP_RIGHT });
      });
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setSearched(true);
    setPageNo(1);
    setDeepLinkStudentId(0);
    setLastSearchType(userType);
    setLastSearchCode(memberCode.trim());
    fetchHistory(memberCode, userType, 1, pageSize);
  };

  useEffect(() => {
    const studentId = parseInt(searchParams.get("studentId") || "0", 10) || 0;
    const type = searchParams.get("type") === "staff" ? "staff" : "student";
    const code = searchParams.get("code") || "";

    if (studentId > 0) {
      setDeepLinkStudentId(studentId);
      setUserType("student");
      setSearched(true);
      setLastSearchType("student");
      setPageNo(1);
      setLoading(true);

      axios({
        method: "post",
        url: config.base_url + "Student/GetStudentByID",
        headers: { "Content-Type": "application/json" },
        data: {
          AccessKey: AccessKey,
          UserID: UserID,
          MemberType: MemberType,
          ID: studentId,
        },
      })
        .then(function (response) {
          if (response.data.status_code === 1 && response.data.Student) {
            const reg = response.data.Student.Registration_No || "";
            setMemberCode(reg);
            setLastSearchCode(reg);
            fetchHistory(reg, "student", 1, pageSize, studentId);
          } else {
            setLoading(false);
            fetchHistory("", "student", 1, pageSize, studentId);
          }
        })
        .catch(function () {
          setLoading(false);
          fetchHistory("", "student", 1, pageSize, studentId);
        });
      return;
    }

    if (code.trim()) {
      setUserType(type);
      setMemberCode(code.trim());
      setSearched(true);
      setLastSearchType(type);
      setLastSearchCode(code.trim());
      fetchHistory(code.trim(), type, 1, pageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!searched) return;
    if (deepLinkStudentId > 0) {
      fetchHistory(lastSearchCode, lastSearchType, pageNo, pageSize, deepLinkStudentId);
    } else if (lastSearchCode) {
      fetchHistory(lastSearchCode, lastSearchType, pageNo, pageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNo, pageSize]);

  const exportCsv = () => {
    if (!listOfRecords || listOfRecords.length === 0) {
      toast.error("No data to export.", { position: toast.POSITION.TOP_RIGHT });
      return;
    }
    csvDownload({
      data: listOfRecords.map((item) => ({
        Book_No: item.Book_No,
        Book_Name: item.Name_Of_Book,
        Issue_Date: item.Date_Of_Issue ? moment(item.Date_Of_Issue).format(config.date_format) : "",
        Due_Date: item.Return_Date ? moment(item.Return_Date).format(config.date_format) : "",
        Return_Date: item.Actual_Return_Date
          ? moment(item.Actual_Return_Date).format(config.date_format)
          : "",
        Status: item.Status,
        Fine: item.Fine || 0,
        Remarks: item.Remarks || "",
      })),
      filename: "library-borrow-history",
    });
  };

  const renderRows = () => {
    if (listOfRecords != null && listOfRecords.length > 0) {
      let count = 1;
      return listOfRecords.map((item, index) => (
        <tr key={index}>
          <td>{count++ + pageSize * (pageNo - 1)}</td>
          <td>{item.Book_No}</td>
          <td>{item.Name_Of_Book}</td>
          <td>{item.Date_Of_Issue ? moment(item.Date_Of_Issue).format("DD/MM/YYYY") : ""}</td>
          <td>{item.Return_Date ? moment(item.Return_Date).format("DD/MM/YYYY") : ""}</td>
          <td>
            {item.Actual_Return_Date
              ? moment(item.Actual_Return_Date).format("DD/MM/YYYY")
              : "-"}
          </td>
          <td>{item.Status}</td>
          <td>{item.Fine > 0 ? item.Fine : "-"}</td>
          <td>{item.Remarks}</td>
        </tr>
      ));
    }
    if (searched) {
      return (
        <tr>
          <td colSpan="9">
            <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
    return (
      <tr>
        <td colSpan="9">
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            Search by student registration or employee code.
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <LibraryMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/Dashboard">Dashboard</NavLink>
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/Library/LibraryDashboard">Library</NavLink>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Borrow History
                  </li>
                </ol>
              </nav>
              <div className="page-title">Borrow History</div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="card mb-2">
            <div className="card-body p-md-4">
              <Form onSubmit={handleSearch}>
                <div className="row align-items-end">
                  <div className="col-md-3">
                    <label>Member type</label>
                    <select
                      className="form-select"
                      value={userType}
                      onChange={(e) => setUserType(e.target.value)}
                    >
                      <option value="student">Student</option>
                      <option value="staff">Staff</option>
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label>{userType === "student" ? "Registration No" : "Employee Code"}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={memberCode}
                      onChange={(e) => setMemberCode(e.target.value)}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <button type="submit" className="button button-primary w-100">
                      Search
                    </button>
                  </div>
                  <div className="col-md-3 text-end">
                    <span className="counting">{totalRecords} Records</span>
                  </div>
                </div>
              </Form>
            </div>
          </div>

          <div className="card">
            <div className="card-body table_card">
              <table className="table table-theme table-hover">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th>Book No</th>
                    <th>Book Name</th>
                    <th>Issue Date</th>
                    <th>Due Date</th>
                    <th>Return Date</th>
                    <th>Status</th>
                    <th>Fine</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="9">
                        <Spinner animation="border" role="status"></Spinner>
                      </td>
                    </tr>
                  ) : (
                    renderRows()
                  )}
                </tbody>
              </table>

              {totalRecords > pageSize && (
                <div className="pagination-wrap">
                  <Pagination
                    pageNo={pageNo}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={setPageNo}
                  />
                </div>
              )}
            </div>
          </div>

          {listOfRecords.length > 0 && (
            <div className="card mt-md-3">
              <div className="card-body text-end">
                <button type="button" className="button button-primary" onClick={exportCsv}>
                  Export CSV
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BorrowHistory;
